import { animate, group, query, style, transition, trigger } from '@angular/animations';
import { Component, inject } from '@angular/core';
import { IpbLoadingService } from './ipb-loading.service';

@Component({
	selector: 'ipb-loading',
	templateUrl: './ipb-loading.component.html',
	styleUrls: ['./ipb-loading.component.scss'],
	animations: [
		trigger('routeAnimations', [
			transition('* <=> *', [
				query(':enter, :leave', [style({ opacity: 0 })], { optional: true }),
				query(':leave', [style({ opacity: 0, position: 'absolute' })], { optional: true }),
				group([
					query(':enter', [animate('400ms linear', style({ opacity: 1 }))], {
						optional: true,
					}),
				]),
			]),
		]),
	],
})
export class IpbLoadingComponent {
	#ipbLoadingService = inject(IpbLoadingService);

	public onLoading$ = this.#ipbLoadingService.onLoading$;
}
